import { CertificateRequest } from '@/shared/types/certificate-request';
import { DraftInput } from './api/certificateRequestApi';

/**
 * Forma do formulário da etapa 1.
 *
 * Campos de texto simples em vez do objeto da API: o input controlado precisa
 * de string, não de `null`, e a conversão fica num lugar só.
 */
export interface IncidentFormValue {
  incidentType: string | null;
  incidentDate: string | null;
  incidentTime: string | null;
  description: string;
  postalCode: string;
  state: string;
  city: string;
  district: string;
  street: string;
  number: string;
  complement: string;
}

export function toFormValue(request: CertificateRequest): IncidentFormValue {
  return {
    incidentType: request.incidentType,
    incidentDate: request.incidentDate,
    incidentTime: request.incidentTime,
    description: request.description ?? '',
    postalCode: request.location?.postalCode ?? '',
    state: request.location?.state ?? '',
    city: request.location?.city ?? '',
    district: request.location?.district ?? '',
    street: request.location?.street ?? '',
    number: request.location?.number ?? '',
    complement: request.location?.complement ?? '',
  };
}

export function toDraftInput(value: IncidentFormValue): DraftInput {
  return {
    incidentType: value.incidentType,
    incidentDate: value.incidentDate,
    incidentTime: value.incidentTime,
    description: value.description,
    location: {
      postalCode: value.postalCode,
      state: value.state,
      city: value.city,
      district: value.district,
      street: value.street,
      number: value.number,
      complement: value.complement,
    },
  };
}

/** Validação da etapa 1. Mesma regra do domínio, para avisar antes da ida ao servidor. */
export function validateIncidentForm(
  value: IncidentFormValue,
  today = new Date().toISOString().slice(0, 10),
): Record<'incidentType' | 'incidentDate' | 'incidentTime', string> {
  return {
    incidentType: value.incidentType ? '' : 'Escolha a natureza do fato.',
    incidentDate: !value.incidentDate
      ? 'Informe a data, mesmo que aproximada.'
      : value.incidentDate > today
        ? 'A data não pode estar no futuro.'
        : '',
    incidentTime: value.incidentTime ? '' : 'Informe o horário aproximado.',
  };
}
